import { useProcessor } from "./useProcessor";


export const useSpendFiado = ()=>{


    const {
        processPayment
    } = useProcessor()

    const createProccesorObject = (data,originCurrencyId,destinationCurrencyId)=>{


        let object =  {
             originCurrencyId: originCurrencyId,
             destinationCurrencyId: destinationCurrencyId,
             products: [
                 {
                     "id": data.id,
                     "amount": data.amount,
                     "paymentAccountNumber":data.paymentAccountNumber,
                     "description":data.description,
                     "saveAsFavorite":data.saveAsFavorite
                 },
                 {
                     "id": "FIADO_FUNDS_AVAILABLE_MXN"
                 }
             ]
         }

   
     
         return object;
       }

        const process = async (data,originCurrencyId,destinationCurrencyId,idempotencyKey)=>{
 
            let dataLocal = null
            if(data.products.length == 1){
                dataLocal = data.products[0];
            }
           
            let processorData  = createProccesorObject(dataLocal,originCurrencyId,destinationCurrencyId)
           // console.log(processorData)
            return await processPayment(processorData,idempotencyKey)
        }

       return {
        process,
        createProccesorObject
       }

}